'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { useLayoutEffect, useRef } from 'react';
import { CommandMenu } from '@/components/command-menu';
import { Link } from '@/components/ui/link';
import { Logo } from '@/components/ui/logo';
import { MobileNav } from './mobile-nav';
import { Navbar } from './navbar';
import { SkipNav } from './skip-nav';
import { ThemeSwitcher } from './theme-switcher';
const SCROLL_THRESHOLD = 100;
export function LayoutHeader() {
  const $ = _c(11);
  const headerRef = useRef(null);
  const rafRef = useRef(null);
  const t = useTranslations();
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const handleScroll = () => {
        if (rafRef.current !== null) {
          return;
        }
        rafRef.current = requestAnimationFrame(() => {
          if (headerRef.current) {
            const isScrolled = window.scrollY > SCROLL_THRESHOLD;
            const currentScrolled = headerRef.current.dataset.scrolled === "true";
            if (isScrolled !== currentScrolled) {
              headerRef.current.dataset.scrolled = String(isScrolled);
            }
          }
          rafRef.current = null;
        });
      };
      window.addEventListener("scroll", handleScroll, {
        passive: true
      });
      handleScroll();
      return () => {
        window.removeEventListener("scroll", handleScroll);
        if (rafRef.current !== null) {
          cancelAnimationFrame(rafRef.current);
        }
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useLayoutEffect(t0, t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <SkipNav />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t("common.labels.home");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Logo width={20} aria-hidden="true" />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3) {
    t5 = <Link href="/" aria-label={t3}>{t4}</Link>;
    $[6] = t3;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="flex items-center gap-2"><Navbar /><ThemeSwitcher /><CommandMenu /><MobileNav /></div>;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t5) {
    t7 = <header ref={headerRef} className="fixed inset-x-0 top-4 z-40 mx-auto flex h-15 max-w-5xl items-center justify-between rounded-2xl bg-background/30 px-8 shadow-xs backdrop-blur-md transition-colors data-[scrolled=true]:bg-background/80">{t2}{t5}{t6}</header>;
    $[9] = t5;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
}